var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSixColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.8332C16.2284 23.8332 14.2653 19.0318 16.25 16.7915C17.9435 14.8799 23.8333 15.7545 23.8333 12.9998C23.8333 7.01675 18.9831 2.1665 13 2.1665C7.01691 2.1665 2.16667 7.01675 2.16667 12.9998C2.16667 18.9829 7.01691 23.8332 13 23.8332Z",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 9.2085C16.0642 9.2085 16.7917 8.48098 16.7917 7.5835C16.7917 6.68601 16.0642 5.9585 15.1667 5.9585C14.2692 5.9585 13.5417 6.68601 13.5417 7.5835C13.5417 8.48098 14.2692 9.2085 15.1667 9.2085Z",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 11.375C9.56416 11.375 10.2917 10.6475 10.2917 9.75C10.2917 8.85251 9.56416 8.125 8.66667 8.125C7.76918 8.125 7.04167 8.85251 7.04167 9.75C7.04167 10.6475 7.76918 11.375 8.66667 11.375Z",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20833 18.4165C10.1058 18.4165 10.8333 17.689 10.8333 16.7915C10.8333 15.894 10.1058 15.1665 9.20833 15.1665C8.31084 15.1665 7.58333 15.894 7.58333 16.7915C7.58333 17.689 8.31084 18.4165 9.20833 18.4165Z",
    stroke: "currentColor",
    strokeWidth: 1.625,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSixColors);
export default __webpack_public_path__ + "static/media/icon-six-colors.dac14702ca6b2f01cf852554d047d061.svg";
export { ForwardRef as ReactComponent };